import { cn } from '@/lib/utils'

interface SkeletonProps {
  className?: string
  width?: string | number
  height?: string | number
  variant?: 'text' | 'circular' | 'rectangular'
}

export const Skeleton = ({
  className,
  width,
  height,
  variant = 'rectangular'
}: SkeletonProps) => {
  const baseStyles = 'animate-pulse bg-gray-200'

  const variantStyles = {
    text: 'rounded',
    circular: 'rounded-full',
    rectangular: 'rounded-lg'
  }

  const style: React.CSSProperties = {}
  if (width) style.width = typeof width === 'number' ? `${width}px` : width
  if (height) style.height = typeof height === 'number' ? `${height}px` : height

  return (
    <div
      className={cn(baseStyles, variantStyles[variant], className)}
      style={style}
    />
  )
}

export const SkeletonText = ({ lines = 1, className }: { lines?: number; className?: string }) => {
  return (
    <div className={cn('space-y-2', className)}>
      {Array.from({ length: lines }).map((_, i) => (
        <Skeleton
          key={i}
          className={cn('h-4', i === lines - 1 && lines > 1 && 'w-3/4')}
        />
      ))}
    </div>
  )
}

export const SkeletonInput = ({ className }: { className?: string }) => {
  return <Skeleton className={cn('h-10 w-full', className)} />
}

export const SkeletonButton = ({ className }: { className?: string }) => {
  return <Skeleton className={cn('h-10 w-24', className)} />
}

export const SkeletonBadge = ({ className }: { className?: string }) => {
  return <Skeleton className={cn('h-6 w-20 rounded-full', className)} />
}

export const SkeletonCard = ({ className, children }: { className?: string; children?: React.ReactNode }) => {
  return (
    <div className={cn('bg-white rounded-xl p-6 shadow-sm border-2 border-gray-100', className)}>
      {children}
    </div>
  )
}

export const SkeletonAlert = ({ className }: { className?: string }) => {
  return (
    <div className={cn('rounded-lg border p-4 space-y-2', className)}>
      <Skeleton className="h-5 w-1/3" />
      <Skeleton className="h-4 w-full" />
      <Skeleton className="h-4 w-5/6" />
    </div>
  )
}
